import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/task.status.type.enum';

/** Localized human-readable string representations of {@link TaskStatusTypeEnum} enumeration values  */
export const TaskStatusTypeEnumI18n: Record<I18nLocalesEnum, Record<TaskStatusTypeEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaskStatusTypeEnum.DRAFT]: 'Заполнение',
    [TaskStatusTypeEnum.SCHEDULED]: 'Запланирован',
    [TaskStatusTypeEnum.ON_APPROVAL]: 'Согласование',
    [TaskStatusTypeEnum.AGREED]: 'Согласован',
    [TaskStatusTypeEnum.PAID]: 'Оплачен',
    [TaskStatusTypeEnum.UNDERPAYMENT]: 'Недоплата',
    [TaskStatusTypeEnum.OVERPAYMENT]: 'Переплата',
    [TaskStatusTypeEnum.REFUSED]: 'Отказан',
    [TaskStatusTypeEnum.CUSTOM]: 'Пользовательский дополнительный статус',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaskStatusTypeEnum.DRAFT]: 'Fill',
    [TaskStatusTypeEnum.SCHEDULED]: 'Scheduled',
    [TaskStatusTypeEnum.ON_APPROVAL]: 'On approval',
    [TaskStatusTypeEnum.AGREED]: 'Agreed',
    [TaskStatusTypeEnum.PAID]: 'Paid',
    [TaskStatusTypeEnum.UNDERPAYMENT]: 'Underpayment',
    [TaskStatusTypeEnum.OVERPAYMENT]: 'Overpayment',
    [TaskStatusTypeEnum.REFUSED]: 'Refused',
    [TaskStatusTypeEnum.CUSTOM]: 'Custom user status',
  },
};
